"use client"
import {
  button_default
} from "./chunk-4RZJ54WQ.js";

// src/controls/anchor/anchor.tsx
import { trackEvent } from "@a24/analytics";
import { useCallback, useEffect, useState } from "react";
import { jsx } from "react/jsx-runtime";
var Anchor = ({ className, id, label, target }) => {
  const [targetElement, setTargetElement] = useState(
    void 0
  );
  const [hasScrolled, setHasScrolled] = useState(false);
  const onAnchorClick = useCallback(() => {
    setHasScrolled(false);
    setTargetElement(target);
    trackEvent({
      name: "button_interaction",
      data: { value: "Anchor|Previous" }
    });
  }, [target]);
  useEffect(() => {
    if (targetElement && !hasScrolled)
      document.getElementById(targetElement)?.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center"
      });
    setHasScrolled(true);
  }, [hasScrolled, targetElement]);
  return /* @__PURE__ */ jsx("div", { className, id, children: /* @__PURE__ */ jsx(
    button_default,
    {
      a11yLabel: label,
      className: "button-primary w-fit",
      label,
      onClick: onAnchorClick
    }
  ) });
};
var anchor_default = Anchor;

export {
  anchor_default
};
